module.exports = __webpack_public_path__ + "static/media/service-3.f2eb879c.png";